<template>
  <div id="content">
    <v-card class="justify-center">
      <v-card-title>
        Periode niet beschikbaar als instapperron
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="assignmentExceptions"
        hide-default-footer
        :items-per-page="1000"
      >
        <template v-slot:item.available="{ item }">
          <span v-if="item.available">
            ja
          </span>
          <span v-else>
            nee
          </span>
        </template>
        <template v-slot:item.enabled="{ item }">
          <span v-if="item.enabled">
            ja
          </span>
          <span v-else>
            nee
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small v-on:click.stop="deleteAssignmentException(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="secondary" fixed bottom right fab @click="newQuayException">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Nieuwe buitendienststelling</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="new_assignment_exception" v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <span class="subtitle-2">Starttijd:</span>
                  <datetime v-model="startdatetime" :minute-step="5" type="datetime" title="Start"></datetime>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <span class="subtitle-2">Eindtijd:</span>
                  <datetime v-model="enddatetime" :minute-step="5" type="datetime" title="Einde"></datetime>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="9">
                  <v-select
                    v-model="selectedQuays"
                    :items="availableQuays"
                    :menu-props="{ maxHeight: '400' }"
                    label="Actief op perrons"
                    multiple
                    hint="Kies de perrons waarop deze buitendienststelling van toepassing is."
                    chips
                    persistent-hint
                    :rules="[v => v.length > 0 || 'Selecteer tenminste een perron.']"
                    required
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="available"
                    label="Toon voorkeurperron op overzichtsdisplay"
                    hint="Als deze aan staat kan een bus op het overzichtsdisplay worden toegewezen aan dit perron."
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="enabled"
                    label="Gebruik aankomstlus"
                    hint="Wanneer aan kan bus worden gedetecteerd op een halte."
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Annuleer</v-btn>
          <v-btn color="blue darken-1" text @click="saveAssignmentException">Opslaan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";


export default {
  data() {
    return {
      headers: [
        {
          text: "Starttijd",
          align: "start",
          value: "starttime"
        },
        { text: "Eindtijd", value: "endtime" },
        { text: "Tonen voorkeurperron", value: "available" },
        { text: "Gebruik aankomstlus", value: "enabled" },
        { text: "Geldt voor perrons", value: "sidecodes" },
        { text: "", value: "actions", sortable: false }
      ],
      dialog: false,
      startdatetime: moment().format(),
      enddatetime: moment()
        .add(2, "days")
        .format(),
      available: true, 
      enabled: false,
      availableQuays: [
        {value: "NL:Q:54447710", text: "A"},
        {value: "NL:Q:54447610", text: "B"},
        {value: "NL:Q:54447510", text: "C"},
        {value: "NL:Q:54447410", text: "D"},
        {value: "NL:Q:54447310", text: "E"},
        {value: "NL:Q:54447210", text: "F"},
        {value: "NL:Q:54447110", text: "G"}
      ],
      assignmentExceptions: [],
      selectedQuays: [],
      valid: false,
    };
  },
  mounted() {
    this.loadAssignmentExceptions();
  },
  methods: {
    loadAssignmentExceptions () {
      this.$http.get("/assignment_exceptions").then(response => {
        this.assignmentExceptions = response.data;
      });
    },
    newQuayException: function(event) {
      this.dialog = true;
      this.available = false;
      this.enabled = true;
    },
    saveAssignmentException: function(event) {
      this.$refs.new_assignment_exception.validate();
      if (this.valid) {
        this.createAssignmentException(event);
        this.dialog = false;
      }
    },
    createAssignmentException: function(event) {
      this.$http
        .post("/assignment_exception", {
          starttime: this.startdatetime,
          endtime: this.enddatetime,
          enabled: this.enabled,
          available: this.available,
          quays: this.selectedQuays,
          stopplacecode: "NL:S:54447000"
        })
        .then(response => {
          this.assignmentExceptions.push(response.data);
          // this is uggly but it is the easiest method to get it working.
          this.loadAssignmentExceptions();
        });
    },
    deleteAssignmentException: function(event) {
      this.$http
        .delete("/assignment_exception/" + event.id)
        .then(response => {
          const index = this.assignmentExceptions.indexOf(event);
          this.assignmentExceptions.splice(index, 1);
        });
    },
  }
};
</script>

<style scoped>
#content {
  max-width: 1000px;
  align-content: center;
}
</style>
